export default __webpack_public_path__ + "static/media/af3.76597c23.jpg";